import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VxCard from "../../../components/VxCard.vue";
export default {
  components: {
    VxCard: VxCard
  },
  name: "Phones.vue",
  data: function data() {
    var _this$phonesData;

    var list = (_this$phonesData = this.phonesData) === null || _this$phonesData === void 0 ? void 0 : _this$phonesData.map(function (item) {
      return item.phone ? item : {
        phone: item,
        label: ""
      };
    });
    return {
      phones: list || []
    };
  },
  methods: {
    addPhone: function addPhone() {
      this.phones.push({
        phone: "",
        label: ""
      });
    },
    getPhones: function getPhones() {
      return this.phones;
    },
    deletePhone: function deletePhone(index) {
      this.phones = this.phones.filter(function (item, i) {
        return i !== index;
      });
    }
  },
  props: {
    phonesData: {
      type: Array,
      required: true
    }
  }
};